<script>
import PageHeader from '@/components/organism/PageHeader'
import PageFooter from '@/components/organism/PageFooter'
import onMessage from '@/modules/mixins/onMessage'
import InitLocation from '@/components/organism/location/InitLocation'
import ModalDeliveryTime from '@/components/organism/modal/ModalDeliveryTime'
import ImpersonateBar from '@/components/organism/ImpersonateBar.vue'

export default {
    name: 'Main',

    components: {
        Overlay: () => import(/* webpackPrefetch: true */ '@/components/atoms/Overlay'),
        ToggleCart: () => import('@/components/atoms/ToggleCart.vue'),
        ModalLeavingCanteenScope: () =>
            import('@/components/organism/modal/ModalLeavingCanteenScope'),
        PageFooter,
        PageHeader,
        InitLocation,
        ModalDeliveryTime,
        ImpersonateBar,
    },

    mixins: [onMessage],

    computed: {
        smDevice() {
            return this.$store.getters[`smDevice`]
        },
        initialized() {
            return !this.$store.getters['site/initialized']
        },
    },
}
</script>

<template lang="pug">
main
    overlay
    page-header
    modal-delivery-time
    init-location
    modal-leaving-canteen-scope
    .main
        transition(name="fade" mode="out-in")
            router-view(:key="$route.params.id")
    toggle-cart(v-if="smDevice")
    
    page-footer.mt-auto(v-if="initialized")
</template>
